<template>
    <div class="view view--startdesks">
        <startdesk-list v-bind:sortable="true"
                        v-bind:user-id="user.id"
                        v-if="!user.is_admin"
        />

        <startdesk-list v-bind:show-add-button="false"
                        v-bind:show-bulk-actions="true"
                        v-bind:show-filters="{ 'category': true, 'created_at': true, 'is_active_admin': true, 'is_default': true, 'is_visible_to_user': true, 'updated_at': true, 'search': true, 'user_type': true, 'search_by_owner': true }"
                        v-bind:show-paging="true"
                        v-bind:show-sort="true"
                        v-bind:show-title="false"
                        v-if="user.is_admin"
        />
    </div>
</template>

<script>
    import startdeskList from '../../components/StartdeskList.vue';

    export default {
        components: {
            startdeskList
        }
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/views/startdesks/Index.vue